import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useLocalStorage } from '@uidotdev/usehooks';
function isLocalStorageAvailable(): boolean {
  try {
    const test = '__test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
}

/**
 * localStorage hook that no-ops when storage is unavailable (private mode, quota).
 */
export function useSafeLocalStorage(key, defaultValue) {
  const $ = _c(6);
  const [value, setValue] = useLocalStorage(key, defaultValue);
  let t0;
  if ($[0] !== key || $[1] !== setValue) {
    t0 = newValue => {
      ;
      try {
        if (isLocalStorageAvailable()) {
          setValue(newValue);
        }
      } catch (t1) {
        const error = t1;
        console.warn(`Failed to set ${key} in localStorage:`, error);
      }
    };
    $[0] = key;
    $[1] = setValue;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const safeSetValue = t0;
  let t1;
  if ($[3] !== safeSetValue || $[4] !== value) {
    t1 = [value, safeSetValue];
    $[3] = safeSetValue;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}